export enum DomainUserTypeValue {
  DOMAIN_ADMIN = 'domain-admin',
  LENS_SUPPORT = 'lens-support',
}

export interface DomainUserType {
  id: number;
  value: DomainUserTypeValue;
}
